export default "__VITE_ASSET__74db69ec__"